module.exports = __webpack_public_path__ + "static/media/8022.d21a6dd9.jpg";